export const queryKeys = {
  ITEMS_LISTING: 'items-listing',
  CATEGORIES_LISTING: 'categories-listing',
};
